import gql from "graphql-tag";
import store from "./Redux/Store";
export const lenghtCount =
  localStorage.getItem("role") === "ADMIN"
    ? `query{
  allUsersdata(where:{createdby:${localStorage.getItem("id")}}) {
        totalCount
      }
  allCampaigns(where:{active:1,campaignadminid:${localStorage.getItem("id")}}) {
        totalCount
         Campaigns {
      id
    }
    }
  allCustomers(where:{createdby:${localStorage.getItem("id")}}){
      totalCount
    }
  }`
    : localStorage.getItem("role") === "SADMIN"
    ? `query{
  allUsersdata {
        totalCount
      }
  allCampaigns(where:{active:1}) {
        totalCount
    }
  allCustomers{
      totalCount
    }
  }`
    : localStorage.getItem("role") === "CAMPAIGNMANAGER"
    ? `query{
  allCampaigns(where:{active:1,campaignmanagerid:${localStorage.getItem(
    "id"
  )}}) {
        totalCount
         Campaigns {
      id
    }
    }
  }`
    : `query{
  allCampaigns(where:{active:1,customerid:${localStorage.getItem(
    "customer"
  )}}) {
        totalCount
        Campaigns {
      id
    }
    }
     
  }`;

export const contactCount = gql`
  query($obj: JSON, $where: JSON) {
    allContacts(where: $where) {
      totalCount
    }
    leads: allContacts(where: $obj) {
      totalCount
    }
  }
`;

export const usersQuery = (limit, offset) => {
  return `query{
        all: allUsersdata(last:${limit}, first:${offset}){
          totalCount
              Usersdata{
                firstName
                lastName
                email 
                role
                contactnumber
                status
                id
              }
            } 
          active: allUsersdata (last:${limit}, first:${offset},where:{status:1}){
            totalCount
                  Usersdata{
                    firstName
                    lastName
                    email 
                    role
                    contactnumber
                    status
                    id
                  }
          }
          inactive: allUsersdata (last:${limit}, first:${offset},where:{status:0}){
            totalCount
                  Usersdata{
                    firstName
                    lastName
                    email 
                    role
                    contactnumber
                    status
                    id
                  }
                }
      }`;
};

export const userSearch = (limit, offset) => {
  return `query ($where: JSON) {
  all:allUsersdata(where: $where,last:${limit}, first:${offset}) {
    totalCount
      Usersdata{
          firstName
          lastName
          email 
          role
          contactnumber
          status
          id
          abm
          createdby
      }
  }
}`;
};
export const userData = `query ($where: JSON) {
  allUsersdata(where: $where) {
  
      Usersdata{
          firstName
          lastName
          email 
          role
          contactnumber
          status
          id
          createdby
      }
  }
}`;

export const customersInfo = (limit, offset) => {
  return localStorage.getItem("role") === "ADMIN"
    ? `query ($where: JSON) {
    allCustomers(where: $where, last: ${limit}, first: ${offset}) {
      totalCount
      Customers {
        id
        firstName
        lastName
        company
        contactno
        email
        active 
      LIVE: campaignfk(where:{status:LIVE,createdby:${localStorage.getItem(
        "id"
      )}}) {
        totalCount
      }
      NotStarted: campaignfk(where:{status:NOTSTARTED,createdby:${localStorage.getItem(
        "id"
      )}}) {
        totalCount
         Campaigns{
          createdby
        }
      }
      PAUSED: campaignfk(where:{status:PAUSED,createdby:${localStorage.getItem(
        "id"
      )}}) {
        totalCount
        
      }
      COMPLETED: campaignfk(where:{status:COMPLETED,createdby:${localStorage.getItem(
        "id"
      )}}) {
        totalCount 
      }
      }
    }
  }`
    : `query ($where: JSON) {
    allCustomers(where: $where, last: ${limit}, first: ${offset}) {
      totalCount
      Customers {
        id
        firstName
        lastName
        company
        contactno
        email
        active
        Campaigns: campaignfk {
        totalCount
        Campaigns{
          status
          createdby
        }
      }
      LIVE: campaignfk(where:{status:LIVE}) {
        totalCount
      }
      NotStarted: campaignfk(where:{status:NOTSTARTED}) {
        totalCount
      }
      PAUSED: campaignfk(where:{status:PAUSED}) {
        totalCount
      }
      COMPLETED: campaignfk(where:{status:COMPLETED}) {
        totalCount
      }
      }
    }
  }`;
};

export const contactInfo = (limit, offset) => {
  return `query($where: JSON) {
    allContacts(where: $where,last:${limit}, first:${offset}) {
      totalCount
      Contacts {
        id
        profileimage
        image
       name
        linkedinid
        campaignid
        designation
        organization
        campaignstatus
        location
          country
    state 
        Campaigns: campaignIbfk4rel{
          Campaigns{
            name
            Profile:customercredentialsIbfk1rel{
              Customerlinkedinprofiles{
                name
              }
             }
            Customers: customerIbfk1rel{
              Customers{
                company
                firstName
                lastName
              }
            }
          }
        }
    }
  }
}`;
};

export const queryConfig1 = obj => {
  return {
    query: gql`
      query Usersdata($id: ID!) {
        result: Usersdata(id: $id) {
          totalCount
          results(where:{id:${obj}} ) {
            name
            email
            id
          }
        }
      }
    `
  };
};

export const CampaignInfo = (limit, offset) => {
  return gql`query($where: JSON) {
    allCampaigns(where: $where, last: ${limit}, first: ${offset}) {
     totalCount
      Campaigns {
        id
        name
        customerid
        linkedinid
        targetconnections
        campaignmanagerid
        startdate
        status
         logintime
            logouttime
       salesNavigator
       opencontact
            runningCampaign
            invitedcount
            connectedcount
            connectedper
            engagedcount
            engagedper
            leadcount
            leadper
            error
            systemipadd
            datafromcampaign
            type
            freecontact
            weekreqfree
            invitelimit
            invitetoday
            invitefailtoday
            thankscount
            thanksfailcount
            connecttoday
            connectyesterday
         customercredentialsIbfk1rel{
          Customerlinkedinprofiles{
            name           
          }
         }
        customerIbfk1rel{
          Customers {
            firstName
            lastName
            company
          }
        } 
      }
    }
  }`;
};
// export const CampaignInfo = (limit, offset) => {
//   return gql`query($where: JSON) {
//     allCampaigns(where: $where, last: ${limit}, first: ${offset}) {
//      totalCount
//       Campaigns {
//         id
//         name
//         customerid
//         linkedinid
//         targetconnections
//         campaignmanagerid
//         startdate
//         status
//          logintime
//             logouttime
//        salesNavigator
//             runningCampaign
//             error
//             systemipadd
//             datafromcampaign
//             type
//          customercredentialsIbfk1rel{
//           Customerlinkedinprofiles{
//             name           
//           }
//          }
//         customerIbfk1rel{
//           Customers {
//             firstName
//             lastName
//             company
//           }
//         }
        
//         totalInvited: contactfk(where: { active: 1, invitesent:1}) {
//           totalCount           
//         }
//         totalConnected: contactfk(where: { active: 1, inviteconnect: 1, invitesent:1}) {
//           totalCount           
//         }
//         totalEngaged: contactfk(where: { active: 1, engaged: 1 }) {
//           totalCount
//         }
//         totalLeads: contactfk(where: { active: 1, leads: 1 }) {
//           totalCount         
//         }
//       }
//     }
//   }`;
// };

export const CampaignTempListsInfo = (limit, offset) => {
  return `query ($where: JSON){
    allTempcontactsdetails(last:${limit}, first:${offset},where:$where) {
    totalCount
    Tempcontactsdetails {
      id
      campaignid
      profileimage
      name
      fname
     headline
     location
     email
      phonenumber
      organization
      designation
      surname
      gender
      country
      state
         ContactDetailsMessages:     tempcontactmessages_ibfk_1 {
        Tempcontactmessages {
          type
          message
          messagedatetime
          realmsgdatetime
          createdon
        }
      }
    }
  } 
}`;
};

export const CampaignTempListsSelectAll = `query ($where: JSON ,$first:Int, $last:Int){
  allTempcontactsdetails(where:$where , first:$first, last:$last) {
  totalCount
  Tempcontactsdetails {
  id
  campaignid
  profileimage
  name
    templistid
  email
  phonenumber
  country
  city
  organization
  designation
  surname
  gender
  country
  state
      ContactDetailsMessages:    tempcontactmessages_ibfk_1 {
        Tempcontactmessages {
          type
          message
          messagedatetime
          realmsgdatetime
          createdon
        }
      }
  }
  } 
  }`;
//Campaigns

export const getCampaignType= `query ($where:JSON){
    allCampaigns(where:$where){
    Campaigns{
      salesNavigator
    }
    }
  }`;

export const listCampaignTempList = `query ($where:JSON){
    allTemplists(where:$where){
      Templists{
      id
      name
      campaignid
      }
    }
  }`;

export const fetchTempListDetail = `query($where: JSON){
  allTempcontactsdetails(where: $where) {
    totalCount
    Tempcontactsdetails {
      id
      campaignid
      profileimage
        profileurl
      name
      fname
      headline
      location
      email
      phonenumber
         dateofbirth
      connectedon
      organization
      designation
        twitter
      industry
        skype
      numberoffollowers
      surname
      gender
      country
      state
              ContactDetailsMessages:  tempcontactmessages_ibfk_1 {
        Tempcontactmessages {
          type
          message
          messagedatetime
          realmsgdatetime
          createdon
        }
      }

    }
  } 
}`;


// export const TempContacts = id =>
//   `query {
//     allTempcontactsdetails(where:{id: ${id}}) {
//     totalCount
// Tempcontactsdetails {
//        twitter
//       id
//       campaignid
//       profileimage
//         profileurl
//       name
//       fname
//       headline
//       location
//       email
//       phonenumber
//          dateofbirth
//       connectedon
//       organization
//       designation
//         twitter
//       industry
//         skype
//       numberoffollowers
//       surname
//       gender
//       country
//       state
//               ContactDetailsMessages:  tempcontactmessages_ibfk_1 {
//         Tempcontactmessages {
//           type
//           message
//           messagedatetime
//           realmsgdatetime
//           createdon
//         }
//       }

//     }
//     }
//     }`;
export const TempMesg = id =>
  `query{
  allTempcontactmessages(where: {contactid: ${id}}) {
    Tempcontactmessages{
      type
message
messagedatetime
realmsgdatetime
createdon
    }
  }
}
`;
export const campaignDetails = id => {
  return `query{
    Campaigns(id: ${id}) {
    id
    name
    description
    linkedinid
    status
    startdate
    targetconnections
    customerid
    datafromcampaign
    type
    opencontact
    customercredentialsIbfk1rel{
    Customerlinkedinprofiles {
     name
    }
    }
    timezone
    Admin: usersIbfk3rel {
    Usersdata {
    id
    firstName
    lastName
    role
    }
    }
    customerIbfk1rel {
    Customers {
    id
    company
    }
    }
    Manager:usersIbfk1rel {
    Usersdata {
    firstName
    lastName
    }
    }
    Campaignstepfk (where:{active:1}){
    Campaignsteps {
    id
    stepname
    limitperday
    subject
    message
    daysdelay
    sequence
    open
    }
    }
    }
    }`;
};

export const campaignZapierurlDetails = id => {
  return `query{
    Campaigns(id: ${id}) {
    id
    name
    zapierurl
    }
    }`;
};

export const campaignContactsTabList = (limit, offset, campaigIdData) => {
  return `query ($where: JSON) {
  allContacts(where: $where,last:${limit}, first:${offset}) {
  totalCount
  Contacts {
  id
  name
  campaignid
   fname 
  designation
  organization
  location
   profileimage
   image
invitationsent
currentstatus
  connect
  campaignstatus
  contactstatus
 industry
  linkedinid
  email
  twitter
  skype
  phonenumber
  connectedon
  thanksmsgdate
   dateofbirth
   currentstatus
   lastresponse
   followup
nextstepname
nextstepdate
invitesent
surname
gender
  country
    state 
    open
  }
  }
 
  }`;
};
export const campaignContactsTabList2 = (limit, offset) => {
  return `query ($where: JSON)  {
  allTriggernotifications (where: $where,last:${limit}, first:${offset}){
      totalCount
    Triggernotifications{
      id,
      name,
      contactid,
        organization,
        date,
        location,
        position,
        triggerdata,
        triggertype,
        triggerstatus,
        url,
        lastactiondate,
        followup,
        notificationdate
 
    }
  }
}
`;
};

export const campaignContactStatusMutation = gql`
  mutation($where: JSON, $data: JSON) {
    ContactsUpsertWithWhere(where: $where, data: $data) {
      id
    }
  }
`;
// triger status update
export const triggerStatusMutation = gql`
  mutation($where: JSON, $data: JSON) {
    TriggernotificationUpsertWithWhere(where: $where, data: $data) {
      id
    }
  }
`;

export const tempcontactsdetailsMuttion = gql`
  mutation($where: JSON, $data: JSON) {
    TempcontactsdetailsUpsertWithWhere(where: $where, data: $data) {
      id
    }
  }
`;

export const campaignContactLogMaintain = gql`
  mutation($data: JSON) {
    ContactlogsCreate(data: $data) {
      id
    }
  }
`;

export const contactExport = gql`
  mutation($data: JSON) {
    ContactexporthistoryCreate(data: $data) {
      id
    }
  }
`;

//  export const CampaignMoveAllContactToTemp = gql`
//  mutation($campaignId:string,$newCampaignId:string){
//   UsersdataMoveAllContactToTemp(campaignId:$campaignId ,newCampaignId:$newCampaignId){
//     id
//   }
//  }
//  `;
export const campaignEngagedTabList = (limit, offset) => {
  return `query ($where: JSON) {
  allContacts(where: $where,last:${limit}, first:${offset}) {
  totalCount
  Contacts {
  id
  campaignid
  name
   fname 
  designation
  organization
  location
   profileimage
   image
invitationsent
currentstatus
  connect
  campaignstatus
  contactstatus
 industry
  linkedinid
  email
  twitter
  skype
  phonenumber
  connectedon
  thanksmsgdate
   dateofbirth
   currentstatus
   lastresponse
   followup
nextstepname
nextstepdate
invitesent
  country
    state 
  }
  }
  }`;
};

export const campaignNoOpTabList = (limit, offset) => {
  return `query ($where: JSON) {
allContacts(where: $where,last:${limit}, first:${offset}) {
totalCount
Contacts {
id
campaignid
name
designation
organization
location
invitationsent
currentstatus
profileimage
image
connectedon
connect
campaignstatus
contactstatus
 industry
  linkedinid
  email
  twitter
  skype
  phonenumber
  connectedon
  thanksmsgdate
   dateofbirth
     country
    state 
Contactmessagesfk(where:{order:"id asc" }){
  Contactmessages{
  type
  message
  messagedatetime
  createdon
  }
  }
currentStage: Contactworkflowhistoryfk(where: {order: executedon, status: "SUCCESS"}) {
Contactworkflowhistories {
campaignstepid
successflag
status
executedon
nextstep
contactid
contactworkflowhistoryIbfk2rel {
Campaignsteps {
  campaignid
  sequence
  subject
stepname
daysdelay
}
}
}
}

}
}
}`;
};

export const campaignLeadsTabList = (limit, offset) => {
  return `query ($where: JSON) {
  allContacts(where: $where,last:${limit}, first:${offset}) {
  totalCount
  Contacts {
  id
  campaignid
  name
   fname 
  designation
  organization
  location
   profileimage
   image
invitationsent
currentstatus
  connect
  campaignstatus
  contactstatus
 industry
  linkedinid
  email
  twitter
  skype
  phonenumber
  connectedon
  thanksmsgdate
   dateofbirth
   currentstatus
   lastresponse
      followup
nextstepname
nextstepdate
invitesent
  country
    state 
  }
  }
  }`;
};

export const CustomerInfo = `query ($where: JSON) {
  allCustomers(where: $where) {
    Customers {
      id
      company
      email
      firstName
      lastName
    }
  }
}
`;

export const LeadsInfo = (limit, offset) => {
  return `query ($where:JSON){
allContacts(where: $where,last:${limit}, first:${offset}){
totalCount
Contacts{
id
campaignid
name
profileimage
image
linkedinid
contactstatus
campaignstatus
organization
designation
location
  country
    state 
Contactmessagesfk{
Contactmessages{
contactid
type
message
messagedatetime
createdon
}
}
Contactlogs:Contactlogsfk{
Contactlogs{
contactid
action
createdon
}
}
Campaigns: campaignIbfk4rel {
Campaigns {
name
customerid
      Profile:customercredentialsIbfk1rel{
              Customerlinkedinprofiles{
                name
              }
             }
Customers: customerIbfk1rel {
Customers {
company
}
}
}
}
}
}
}`;
};
export const queryConfig = obj => {
  return {
    query: gql`
      query Usersdata($id: ID!) {
        result: Usersdata(id: $id) {
          totalCount
          results {
            name
            email
            id
          }
        }
      }
    `
  };
};

export const campaignContactsTabSelectList = `query ($where: JSON) {
  allContacts(where: $where) {
  totalCount
  Contacts {
  id
  campaignid
  name
  designation
  organization
  location
   profileimage
   image
   invitationsent
currentstatus
  connectedon
  thanksmsgdate
  connect
  campaignstatus
  contactstatus
    country
    state 
  Contactmessagesfk(where:{order: "id desc", type: "RECEIVED"},last:1){
Contactmessages{
message
createdon
}
}
  currentStage: Contactworkflowhistoryfk(where: {order: executedon, status: "SUCCESS"}) {
  Contactworkflowhistories {
  campaignstepid
  successflag
  status
  executedon
  nextstep
  contactid
  contactworkflowhistoryIbfk2rel {
  Campaignsteps {
  stepname
  }
  }
  }
  }

  }
  }
  }`;

export const campaignContactsTabSelectList2 = `query ($where: JSON)  {
  allTriggernotifications (where: $where){
      totalCount
    Triggernotifications{
      id,
      name,
      contactid,
        organization,
        date,
        location,
        position,
        triggerdata,
        triggertype,
        campaignstatus,
        url,
        lastactiondate
    }
    }
  }`;

export const campaignEngagedTabSelectList = `query ($where: JSON) {
  allContacts(where: $where) {
  totalCount
  Contacts {
  id
  campaignid
  name
  designation
  organization
  location
  engaged
   profileimage
   image
  connectedon
  thanksmsgdate
  connect
  campaignstatus
  contactstatus
  followup
    Contactmessagesfk(where:{order: "id desc", type: "RECEIVED"},last:1){
Contactmessages{
message
createdon
}
}
  currentStage: Contactworkflowhistoryfk(where: {order: executedon, status: "SUCCESS"}) {
  Contactworkflowhistories {
  campaignstepid
  successflag
  status
  executedon
  nextstep
  contactid
  contactworkflowhistoryIbfk2rel {
  Campaignsteps {
  stepname
  }
  }
  }
  }
  
  }
  }
  }`;

export const campaignLeadsTabSelectList = `query ($where: JSON) {
allContacts(where: $where) {
totalCount
Contacts {
id
campaignid
name
linkedinid
designation
contactstatus
organization
profileimage
image
campaignstatus
location
connectedon
thanksmsgdate
connect
  country
    state 
Contactmessagesfk(where:{order: "id desc", type: "RECEIVED"},last:1){
Contactmessages{
message
createdon
}
}
currentStage: Contactworkflowhistoryfk(where: {order: executedon, status: "SUCCESS"}) {
Contactworkflowhistories {
campaignstepid
successflag
status
executedon
nextstep
contactid
contactworkflowhistoryIbfk2rel {
Campaignsteps {
stepname
}
}
}
}

Campaigns: campaignIbfk4rel {
Campaigns {
name
customerid
Customers: customerIbfk1rel {
Customers {
company
}
}
}
}
}
} 
}`;

// export const campaignContactsExport = `query ($where: JSON) {
//   allContacts(where: $where) {
//   totalCount
//   Contacts {
//   id
//   campaignid
//   name
//    fname 
//   designation
//   organization
//   location
//    profileimage
//    image
// invitationsent
// currentstatus

//   connect
//   campaignstatus
//   contactstatus
//  industry
//   linkedinid
//   email
//   twitter
//   skype
//   phonenumber
//   connectedon
//   thanksmsgdate
//    dateofbirth
//      country
//     state 
// Contactmessagesfk(where:{order:"id asc" }){
//   Contactmessages{
//   type
//   message
//   messagedatetime
//   createdon
//   }
//   }
//   currentStage: Contactworkflowhistoryfk(where: {order: executedon, status: "SUCCESS"}) {
//   Contactworkflowhistories{
//   campaignstepid
//   successflag
//   status
//   executedon
//   nextstep
//   contactid
//   contactworkflowhistoryIbfk2rel{
//   Campaignsteps {
//    campaignid
//     sequence
//     subject
//   stepname
//   daysdelay
//   }
//   }
//   }
//   }

//   }
//   }
//   }`;

export const campaignContactsExport = `query ($where: JSON) {
  allContacts(where: $where) {
  totalCount
  Contacts {
  id
  campaignid
  name
   fname 
  designation
  organization
  location
   profileimage
   image
invitationsent
currentstatus

  connect
  campaignstatus
  contactstatus
 industry
  linkedinid
  email
  twitter
  skype
  phonenumber
  connectedon
  thanksmsgdate
   dateofbirth
     country
    state 
      surname
      campaignIbfk4rel{
  Campaigns{
    zapierurl
    name
  }
}
Contactmessagesfk(where:{order:"id asc" }){
  Contactmessages{
  type
  message
  messagedatetime
  createdon
  }
  }
  currentStage: Contactworkflowhistoryfk(where: {order: executedon, status: "SUCCESS"}) {
  Contactworkflowhistories{
  campaignstepid
  successflag
  status
  executedon
  nextstep
  contactid
  contactworkflowhistoryIbfk2rel{
  Campaignsteps {
   campaignid
    sequence
    subject
  stepname
  daysdelay
  }
  }
  }
  }

  }
  }
  }`;

  export const campaignContactsExport2 = `query ($where: JSON) {
  allContacts(where: $where) {
  totalCount
  Contacts {
  id
  campaignid
  name
   fname 
  designation
  organization
  location
   profileimage
   image
invitationsent
currentstatus

  connect
  campaignstatus
  contactstatus
 industry
  linkedinid
  email
  twitter
  skype
  phonenumber
  connectedon
  thanksmsgdate
   dateofbirth
     country
    state 
      surname
      campaignIbfk4rel{
  Campaigns{
    zapierurl
    name
  }
}

  }
  }
  }`;
export const campaignFreeContacts = `query ($where: JSON) {
  allContacts(where: $where) {
  totalCount
  
  }
  }`;

// export const campaignEngegedExport = `query ($where: JSON){
    
//     allContacts(where: $where) {
//     totalCount
//     Contacts {
//     id
//     campaignid
//     name
//     fname 
//     designation
//     organization
//     location
//     engaged
//      profileimage
//      image
//   invitationsent
//   currentstatus
//     connect
//     campaignstatus
//     contactstatus
//     industry
//     linkedinid
//     email
//     twitter
//     skype
//     phonenumber
//     connectedon
//      dateofbirth
//      followup
//        country
//     state 
//   Contactmessagesfk(where:{order:"id asc" }){
//     Contactmessages{
//     type
//     message
//     messagedatetime
//     createdon
//     }
//     }
//     currentStage: Contactworkflowhistoryfk(where: {order: executedon, status: "SUCCESS"}) {
//     Contactworkflowhistories {
//     campaignstepid
//     successflag
//     status
//     executedon
//     nextstep
//     contactid
//     contactworkflowhistoryIbfk2rel {
//     Campaignsteps {
//      campaignid
//       sequence
//       subject
//     stepname
//     daysdelay
//     }
//     }
//     }
//     }
    
//     }
//     }
//     }`;

export const campaignEngegedExport = `query ($where: JSON){
    
    allContacts(where: $where) {
    totalCount
    Contacts {
    id
    campaignid
    name
    fname 
    designation
    organization
    location
    engaged
     profileimage
     image
  invitationsent
  currentstatus
    connect
    campaignstatus
    contactstatus
    industry
    linkedinid
    email
    twitter
    skype
    phonenumber
    connectedon
     dateofbirth
     followup
       country
    state 
      surname
      campaignIbfk4rel{
  Campaigns{
    zapierurl
    name
  }
}
  Contactmessagesfk(where:{order:"id asc" }){
    Contactmessages{
    type
    message
    messagedatetime
    createdon
    }
    }
    currentStage: Contactworkflowhistoryfk(where: {order: executedon, status: "SUCCESS"}) {
    Contactworkflowhistories {
    campaignstepid
    successflag
    status
    executedon
    nextstep
    contactid
    contactworkflowhistoryIbfk2rel {
    Campaignsteps {
     campaignid
      sequence
      subject
    stepname
    daysdelay
    }
    }
    }
    }
    
    }
    }
    }`;
    
export const campaignLeadsExport = `query ($where: JSON)  {  
    allContacts(where: $where) {
    totalCount
    Contacts {
    id
    name
    fname
    linkedinid
    campaignid
    designation
    contactstatus
    organization
    profileimage
    image
    campaignstatus
    location
      invitationsent
  currentstatus
    connect
     industry
      linkedinid
      email
      twitter
      skype
      phonenumber
      connectedon
       dateofbirth
         country
    state 
      surname
      campaignIbfk4rel{
  Campaigns{
    zapierurl
    name
  }
}
    Contactmessagesfk(where:{order:"id asc" }){
      Contactmessages{
      type
      message
      messagedatetime
      createdon
      }
      }
    currentStage: Contactworkflowhistoryfk(where: {order: executedon, status: "SUCCESS"}) {
    Contactworkflowhistories {
    campaignstepid
    successflag
    status
    executedon
    nextstep
    contactid
    contactworkflowhistoryIbfk2rel {
    Campaignsteps {
      campaignid
      sequence
      subject
    stepname
    daysdelay
    }
    }
    }
    }
    
    Campaigns: campaignIbfk4rel {
    Campaigns {
    name
    customerid
    Customers: customerIbfk1rel {
    Customers {
    company
    }
    }
    }
    }
    }
    } 
    }`;

export const campaignNoOppExport = `query ($where: JSON) {
    allContacts(where: $where) {
    totalCount
    Contacts {
    id
    name
    campaignid
    fname
    designation
    organization
    location
    profileimage
    image
    connectedon
    connect
    campaignstatus
    contactstatus
     industry
      linkedinid
      email
      twitter
      skype
      phonenumber
      connectedon
       dateofbirth
         country
    state 
    Contactmessagesfk(where:{order:"id asc" }){
      Contactmessages{
      type
      message
      messagedatetime
      createdon
      }
      }
    currentStage: Contactworkflowhistoryfk(where: {order: executedon, status: "SUCCESS"}) {
    Contactworkflowhistories {
    campaignstepid
    successflag
    status
    executedon
    nextstep
    contactid
    contactworkflowhistoryIbfk2rel {
    Campaignsteps {
      campaignid
      sequence
      subject
    stepname
    daysdelay
    }
    }
    }
    }
    
    }
    }
    }`;

export const LeadsExport = `query ($where:JSON) {

allContacts(where: $where){
totalCount
Contacts{
id
campaignid
name
fname
profileimage
image
linkedinid
contactstatus
campaignstatus
organization
designation
location
  country
    state 
Contactmessagesfk{
Contactmessages{
contactid
type
message
messagedatetime
createdon
}
}
Contactlogs:Contactlogsfk{
Contactlogs{
contactid
action
createdon
}
}
Campaigns: campaignIbfk4rel {
Campaigns {
name
customerid
      Profile:customercredentialsIbfk1rel{
              Customerlinkedinprofiles{
                name
              }
             }
Customers: customerIbfk1rel {
Customers {
company
}
}
}
}
}
}
}`;

export const EditRunningCampaignQuery = gql`
  mutation CampaignsUpsertWithWhere($where: JSON, $data: JSON) {
    CampaignsUpsertWithWhere(where: $where, data: $data) {
      id
    }
  }
`;
export const GetAllCampaign = gql`
  query($where: JSON) {
    allCampaigns(where: $where, first:20) {
      totalCount
      Campaigns {
        id
        name
      }
    }
  }
`;

export const ExcelDataQuery = file => gql`mutation{
TempcontactsdetailsUploadUserExcel(fileName:${JSON.stringify(file)})
}`;

export const contactCompany = gql`
query {
  allContactscompanies(where: {order: name},first: 20 ){
    Contactscompanies{
      id
      name
    }
  }
}
`;
// export const contactCompany = gql`
// query ($where: JSON ){
//   allContactscompanies(where: $where, first: 20 ){
//     Contactscompanies{
//       id
//       name
//     }
//   }
// }
// `;
